import React from 'react'

export const TextButton = ({
  type,
  className,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) => {
  className = 'text-btn' + (className ? ` ${className}` : '')

  return <button type={type || 'button'} className={className} {...props}></button>
}
